// src/index.tsx
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./pages/routes/App";
import { applyDisplay, loadDisplay } from "./display";

// Apply saved display settings before the first paint.
applyDisplay(loadDisplay());

const rootElement = document.getElementById("root")!;
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
